export default {"src":"/_next/static/media/license-plate-fill.e7eb31e6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};